module.exports = __webpack_public_path__ + "media/images/samples/300x300/3-5408dc12ba22ed149be1c86ca315466a.jpg";